import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

const ProgressNoteForm = ({ formData, setFormData }) => {
    const [rows, setRows] = useState(
        formData.progressNotes?.length
            ? formData.progressNotes
            : [{ id: Date.now(), date: "", note: "" }]
    );

    // ✅ Sync with fetched data when editing
    useEffect(() => {
        // Only initialize once when editing data arrives (not every time it changes)
        if (formData.progressNotes && formData.progressNotes.length > 0) {
            setRows(formData.progressNotes);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ✅ Keep parent updated
    useEffect(() => {
        setFormData({ ...formData, progressNotes: rows });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rows]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const addRow = () => {
        setRows([...rows, { id: Date.now(), date: "", note: "" }]);
    };

    const removeRow = (id) => {
        if (rows.length === 1) return;
        Swal.fire({
            title: "Delete this entry?",
            text: "This note will be removed.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it",
        }).then((res) => {
            if (res.isConfirmed) {
                setRows(rows.filter((r) => r.id !== id));
            }
        });
    };

    const handleRowChange = (id, field, value) => {
        setRows(rows.map((r) => (r.id === id ? { ...r, [field]: value } : r)));
    };

    return (
        <div className="p-4">
            {/* ==== REPEATER SECTION ==== */}
            <div className="col-12 mb-3">
                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3 px-3 py-1">
                    Daily Progress Notes
                </small>
            </div>

            {rows.map((row) => (
                <div
                    key={row.id}
                    className="border rounded-4 p-3 mb-3 shadow-sm bg-light-subtle"
                >
                    <div className="row g-3">
                        <div className="col-md-10">
                            <textarea
                                rows="3"
                                className="form-control"
                                placeholder="Enter Progress Note"
                                value={row.note}
                                onChange={(e) =>
                                    handleRowChange(row.id, "note", e.target.value)
                                }
                            ></textarea>
                        </div>

                        <div className="col-md-2">
                            <input
                                type="datetime-local"
                                className="form-control"
                                value={row.date}
                                onChange={(e) =>
                                    handleRowChange(row.id, "date", e.target.value)
                                }
                            />
                            <button
                                type="button"
                                className="btn btn-outline-danger btn-sm mt-2 w-100"
                                onClick={() => removeRow(row.id)}
                            >
                                <i className="ri-delete-bin-line"></i>
                            </button>
                        </div>
                    </div>
                </div>
            ))}

            {/* Add Row Button */}
            <div className="text-end mt-3">
                <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={addRow}
                >
                    <i className="ri-add-line"></i> Add Row
                </button>
            </div>
        </div>
    );
};

export default ProgressNoteForm;
